export enum Utils {
    SummaryUtils = 'summary',
    YoutubeUtils = 'youtube',
}
